import React, { useContext } from 'react';

import { Box } from '@mui/material';
import cx from 'classnames';
import { useTranslation } from 'react-i18next';

import CloseIcon from '../../../../assets/icons/CloseIcon';
import IKImage from '../../../../components/IKImage/IKImage';
import { CustomButton } from '../../../../components/UI/CustomButton';
import { DiscoverContext } from '../../../../context/DiscoverContext';
import { colorsPalette, useIsWidthUp } from '../../../../theme';
import useStyles from './style';

interface FiltersOverlayProps {
  logoUrl?: string;
  handleResetFilters: () => void;
  canClearFilters: boolean;
}

export const FiltersOverlay: React.FC<FiltersOverlayProps> = ({
  logoUrl,
  handleResetFilters,
  canClearFilters,
  children,
}) => {
  const { openFiltersPanel, setOpenFiltersPanel, setSearchState, tempSearchState } = useContext(
    DiscoverContext,
  );
  const { t } = useTranslation();
  const classes = useStyles();
  const isMobile = !useIsWidthUp('xl');

  const handleCloseOverlay = () => {
    setSearchState({
      ...tempSearchState,
      page: 1,
    });
    setOpenFiltersPanel(false);
  };

  return (
    <Box className={cx(classes.overlay, openFiltersPanel && classes.overlayOpen)}>
      <Box className={classes.contentWrapper}>
        {isMobile && logoUrl && (
          <Box className={classes.overlayLogoWrapper}>
            <IKImage path={logoUrl || ''} draggable={false} alt={'logo'} />
          </Box>
        )}
        {isMobile && (
          <Box className={classes.closeBtnWrapper}>
            <CloseIcon
              className={classes.closeIcon}
              color={colorsPalette.primary}
              onClick={handleCloseOverlay}
            />
          </Box>
        )}
        {children}
        <Box className={classes.buttonsWrapper}>
          <CustomButton
            color="secondary"
            variant="outlined"
            onClick={handleResetFilters}
            disabled={!canClearFilters}
          >
            {t('button.clearAll')}
          </CustomButton>
          {isMobile && (
            <CustomButton btnClass={classes.applyBtn} onClick={() => setOpenFiltersPanel(false)}>
              {t('button.apply')}
            </CustomButton>
          )}
        </Box>
      </Box>
    </Box>
  );
};

export default FiltersOverlay;
